// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1C591","tabsBox":"styles_tabsBox__2rYjk","createButton":"styles_createButton__1uyEa"};